import {Select} from "antd";
import {useGetStoreServicesOrdersContext} from "../../../../../service-feature/useCases/get-orders/context";

export type OrderFilterOptionValue =
  | "incomplete"
  | "inprogress"
  | "completed"
  | "delivered"
  | "disputeOpened"
  | "refunded"
  | "cancelled";

export const OrdersFilterOptions: {
  label: string;
  value: number;
}[] = [
  // {
  //   label: "Incomplete",
  //   value: "incomplete",
  // },
  {
    label: "All",
    value: -1,
  },
  {
    label: "In progress",
    value: 4,
  },
  {
    label: "Completed",
    value: 3,
  },
  {
    label: "Delivered",
    value: 13,
  },
  {
    label: "Dispute opened",
    value: 15,
  },
  {
    label: "Refunded",
    value: 14,
  },
  {
    label: "Cancelled",
    value: 6,
  },
];

export function OrdersFilter() {
  const {
    state: {statusId},
    dispatch,
  } = useGetStoreServicesOrdersContext();
  return (
    <div>
      <Select
        id="services-orders-filter-select-id"
        size="large"
        style={{width: "100%"}}
        onChange={(value) =>
          dispatch({
            type: "update-status-id",
            payload: value,
          })
        }
        value={statusId}
        options={OrdersFilterOptions}
      />
    </div>
  );
}
